import EdgeLabel from 'src/enums/edgeLabel';
import { Block, Segment } from 'src/types/shared/blocksV3';
import getBlockChildren from './getBlockChildren';
import React from 'react';
import { DeckAction } from 'src/pages/quotations/views/blocks/context/DeckContextV3';

function swapSegmentsBlocksPositions({
	blocks,
	block,
	topSegment,
	bottomSegment,
	scaleFactor,
	dispatch,
}: {
	blocks: Block[];
	block: Block;
	topSegment: Segment;
	bottomSegment: Segment;
	scaleFactor: number;
	dispatch: React.Dispatch<DeckAction>;
}) {
	const topSegmentAttachedBlocks = [
		...blocks,
		...block.bumpouts,
		...block.stairs,
		...block.landings,
	].filter((blk) => blk.parentBlock.segmentId == topSegment.id);

	const bottomSegmentAttachedBlocks = [
		...blocks,
		...block.bumpouts,
		...block.stairs,
		...block.landings,
	].filter((blk) => blk.parentBlock.segmentId == bottomSegment.id);

	for (const attachedBlock of topSegmentAttachedBlocks) {
		const parentAttachedEdge = attachedBlock.edges.find(
			(ed) => ed.attachedToParent
		);
		const widthDimension =
			parentAttachedEdge.label == EdgeLabel.TOP ||
			parentAttachedEdge.label == EdgeLabel.BOTTOM
				? 'width'
				: 'height';

		const children = getBlockChildren(blocks, attachedBlock);

		for (const blk of [attachedBlock, ...children]) {
			const newPosition = {
				...blk.position,
				x:
					widthDimension == 'width'
						? blk.position.x + bottomSegment.length * scaleFactor
						: blk.position.x,
				y:
					widthDimension == 'height'
						? blk.position.y + bottomSegment.length * scaleFactor
						: blk.position.y,
			};

			blk.position = newPosition;

			dispatch({ type: 'UPDATE_BLOCK', payload: blk });
		}
	}

	for (const attachedBlock of bottomSegmentAttachedBlocks) {
		const parentAttachedEdge = attachedBlock.edges.find(
			(ed) => ed.attachedToParent
		);
		const widthDimension =
			parentAttachedEdge.label == EdgeLabel.TOP ||
			parentAttachedEdge.label == EdgeLabel.BOTTOM
				? 'width'
				: 'height';

		const children = getBlockChildren(blocks, attachedBlock);

		for (const blk of [attachedBlock, ...children]) {
			const newPosition = {
				...blk.position,

				x:
					widthDimension == 'width'
						? blk.position.x - topSegment.length * scaleFactor
						: blk.position.x,
				y:
					widthDimension == 'height'
						? blk.position.y - topSegment.length * scaleFactor
						: blk.position.y,
			};

			blk.position = newPosition;

			dispatch({ type: 'UPDATE_BLOCK', payload: blk });
		}
	}
}

export default swapSegmentsBlocksPositions;
